import { z } from "zod"

export const InputMethodSchema = z.enum(["meterPoint", "invoice", "addressLookup"])
